export default __webpack_public_path__ + "static/media/speaker.daafe8a3.png";